import {ChangeDetectionStrategy, Component, inject, input, output, signal} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {Store} from '@ngrx/store';
import {UpdateTaskIconAction} from 'src/app/core/store/challenge-builder/challenge-builder.action';
import {MessageService} from 'src/app/services/message.service';
import {OphLoadingModule} from 'src/app/shared/design/oph-loading/oph-loading.module';
import {CbTaskIconPickerDialogComponent} from '../cb-task-icon-picker-dialog/cb-task-icon-picker-dialog.component';
import {MobileService} from 'src/app/core/page/mobile.service';

@Component({
  selector: 'cb-task-icon-button',
  standalone: true,
  imports: [OphLoadingModule],
  templateUrl: './cb-task-icon-button.component.html',
  styleUrl: './cb-task-icon-button.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CbTaskIconButtonComponent {
  private readonly mobileService = inject(MobileService);
  private dialog = inject(MatDialog);
  private store$ = inject(Store);
  private messageService = inject(MessageService);

  icon = input<string>('');
  taskId = input.required<string>();
  projectId = input<string>('');

  iconChange = output<string>();
  loading = signal(false);

  openIconPicker(): void {
    const dialogRef = this.dialog.open(CbTaskIconPickerDialogComponent, {
      autoFocus: this.mobileService.isMobilePlatform() ? false : undefined,
      backdropClass: 'oph-backdrop',
      panelClass: 'cb-task-icon-picker-dialog-panel',
      width: '100%',
      maxWidth: '1000px',
      height: '100%',
      maxHeight: '800px',
      data: {currentIcon: this.icon()},
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result != null) {
        const projectId = this.projectId();
        const taskId = this.taskId();
        if (projectId && taskId) {
          this.loading.set(true);
          this.store$.dispatch(
            new UpdateTaskIconAction({
              projectId,
              taskId,
              icon: result,
              onSuccess: () => {
                this.loading.set(false);
                this.iconChange.emit(result);
              },
              onFailure: () => {
                this.loading.set(false);
                this.messageService.add('Failed to update task icon', 'error');
              },
            })
          );
        }
      }
    });
  }
}
